import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import { withCookies } from 'react-cookie';

import {
  IntroPage,
  LoginPage,
  AdminMainPage,
  AdminLoginPage,
  RegisterPage,
  MainPage,
  NotFoundPage,
  AuthRoute
} from 'pages';

import './App.css';

class App extends Component {
  render() {
    // cookie에 언어 설정
    const { cookies } = this.props;
    cookies.set('lang', localStorage.getItem('language'), { path: '/' });

    return (
      <Router>
        <div style={{ width: '100%', height: '100%' }}>
          <Switch>
            {/* 로그인 성공 여부와 관계 없이 동일한 페이지 보여줌
                root경로로 들어왔을때 소개페이지로 이동 */}
            <AuthRoute exact path="/" authType={0} accessLevel={1} component={IntroPage} componentName="/" />
            {/* 로그인 성공 인증인 경우 로그인 되었음을 안내하도록 AuthRoute 처리*/}
            <AuthRoute path="/intro" authType={1} accessLevel={1} component={IntroPage} componentName="IntroPage" />
            <AuthRoute path="/login" authType={1} accessLevel={1} component={LoginPage} componentName="LoginPage" />
            <AuthRoute path="/register" authType={1} accessLevel={1} component={LoginPage} componentName="LoginPage" />
            <AuthRoute
              path="/mudlogin"
              authType={1}
              accessLevel={2}
              component={AdminLoginPage}
              componentName="AdminLoginPage"
            />
            {/* 로그인 성공 인증이 필요한 Route는 AuthRoute 처리 */}
            <AuthRoute
              path="/main"
              failPath="/login"
              authType={2}
              accessLevel={1}
              component={MainPage}
              componentName="MainPage"
            />
            <AuthRoute
              path="/mudmanage"
              failPath="/mudlogin"
              authType={2}
              accessLevel={2}
              component={AdminMainPage}
              componentName="AdminMainPage"
            />
            <Route component={NotFoundPage} />
          </Switch>
        </div>
      </Router>
    );
  }
}

export default withCookies(App);



// WEBPACK FOOTER //
// ./src/App.js